module.exports = __webpack_public_path__ + "img/42.b4c5758a.jpg";